<template>
  <b-container fluid>
    <b-row align-h="center" class="d-flex flex-column align-items-center">
      <reviewer-feedback
        v-if="learningUnit && learningUnit.latest_request_changes_at"
        class="mb-4"
        :learning-unit="learningUnit"
      />

      <basic-info class="mb-4" />

      <constructive-design class="mb-4" />

      <session class="mb-4" />

      <post-details
        v-if="learningUnit && defaultSection"
        :learning-unit="learningUnit"
        :section="defaultSection"
        class="mb-4"
      />
    </b-row>
  </b-container>
</template>

<script>
import { learningUnitInfoMixin } from '@/mixins/learningUnitInfoMixin';
import LearningUnit from '@/models/LearningUnit';
import Section from '@/models/Section';
import Post from '@/models/Post';
import PostSchedule from '@/models/PostSchedule';
import BasicInfo from './components/BasicInfo';
import ConstructiveDesign from './components/ConstructiveDesign';
import Session from './components/Session';
import PostDetails from './components/PostDetails';
import ReviewerFeedback from './components/ReviewerFeedback';

export default {
  components: {
    BasicInfo,
    ConstructiveDesign,
    Session,
    PostDetails,
    ReviewerFeedback
  },
  mixins: [learningUnitInfoMixin],

  computed: {
    learningUnitId() {
      return parseInt(this.$route.params.learningUnitId);
    },

    defaultSection() {
      return Section.query()
        .where('learning_unit_id', this.learningUnitId)
        .where('is_default', true)
        .first();
    }
  },

  mounted() {
    this.fetch();
  },

  methods: {
    async fetch() {
      try {
        LearningUnit.deleteAll();
        Section.deleteAll();
        Post.deleteAll();
        PostSchedule.deleteAll();

        await LearningUnit.api().fetchByLearningUnitId(this.learningUnitId);
      } catch (error) {
        this.$toast.error('Cannot load learning unit information, please try again');
      }
    }
  }
};
</script>
